import type { Key, ReactNode } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-aria-components";
import { useSearchParams } from "react-router";
import styles from "./QuestTabs.module.css";

const TEMPLATES = "templates";
const QUESTS = "quests";

type QuestTabsProps = {
  templates: ReactNode;
  quests: ReactNode;
};

export const QuestTabs = ({ templates, quests }: QuestTabsProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedKey = searchParams.get("tab") === QUESTS ? QUESTS : TEMPLATES;

  const handleSelectionChange = (key: Key) => {
    // Built from the current parameters, not from scratch: the filter and the
    // open rows live in the URL too, and switching tabs is not a reason to
    // reset either.
    const params = new URLSearchParams(searchParams);

    params.set("tab", String(key));

    // `replace` because the tab is one state, not a trail of history entries
    // the back button has to walk out of.
    setSearchParams(params, { replace: true, preventScrollReset: true });
  };

  return (
    <Tabs
      selectedKey={selectedKey}
      onSelectionChange={handleSelectionChange}
      className={styles.tabs}
    >
      <TabList aria-label="Quest views" className={styles.tabList}>
        <Tab id={TEMPLATES} className={styles.tab}>
          Templates
        </Tab>
        <Tab id={QUESTS} className={styles.tab}>
          Quests
        </Tab>
      </TabList>
      <TabPanel id={TEMPLATES} className={styles.panel}>
        {templates}
      </TabPanel>
      <TabPanel id={QUESTS} className={styles.panel}>
        {quests}
      </TabPanel>
    </Tabs>
  );
};
